import { render, staticRenderFns } from "./ReturnComponent.vue?vue&type=template&id=190bc7c6"
import script from "./ReturnComponent.vue?vue&type=script&lang=ts"
export * from "./ReturnComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports